<template>
  <div id="BusinessCertificate_PrintTemplate">
    <section class="logo-area">
      <img src="@/assets/img/print/LOGONAME.png" class="logo"/>

      <div class="logo-title">業務資料</div>
    </section>

    <section class="info-area">
      <table cellspacing="0">
        <tr>
          <td width="3%" rowspan="0" class="text-vertical" valign="center" align="center" bgcolor="#93d2fe">業務人員</td>

          <td colspan="5" align="center" bgcolor="#93d2fe">業務員</td>
        </tr>

        <tr>
          <td align="center" bgcolor="#c6c4c4" class="text-weight-bold">業務代碼</td>
          <td align="center" bgcolor="#c6c4c4" class="text-weight-bold">姓名</td>
          <td align="center" bgcolor="#c6c4c4" class="text-weight-bold">出生日期</td>
          <td align="center" bgcolor="#c6c4c4" class="text-weight-bold">身分證</td>
          <td align="center" bgcolor="#c6c4c4" class="text-weight-bold">聘級</td>
        </tr>

        <tr>
          <td align="center">{{ data.number }}</td>
          <td align="center">{{ data.name }}</td>
          <td align="center">{{ convertRocDate(data.birthday) }}</td>
          <td align="center">{{ data.ID_number }}</td>
          <td align="center">{{ data.rank }}</td>
        </tr>

        <tr>
          <td align="center" bgcolor="#c6c4c4" class="text-weight-bold">Line</td>
          <td align="center" colspan="3"></td>
          <td align="center" bgcolor="#c6c4c4" class="text-weight-bold">電話</td>
        </tr>

        <tr>
          <td align="center" bgcolor="#c6c4c4" class="text-weight-bold">E-Mail</td>
          <td align="center" colspan="3"></td>
          <td align="left" class="text-small">手機：{{ data.cellphone }}</td>
        </tr>

        <tr>
          <td align="center" bgcolor="#c6c4c4" class="text-weight-bold">戶籍地址</td>
          <td align="left" colspan="3"></td>
          <td align="left" class="text-small">市話：{{ data.phone }}</td>
        </tr>

        <tr>
          <td align="center" bgcolor="#c6c4c4" class="text-weight-bold">通訊地址</td>
          <td align="left" colspan="3">{{ data.postalCode }}{{ data.address }}</td>
          <td align="left" class="text-small">公司：</td>
        </tr>
      </table>
    </section>

    <section class="info-area">
      <table cellspacing="0">
        <tr>
          <td width="3%" rowspan="0" class="text-vertical" valign="center" align="center" bgcolor="#93d2fe">配偶</td>

          <td colspan="2" align="center" bgcolor="#93d2fe">配偶</td>

          <td colspan="3" align="center" bgcolor="#cff7cb">帶件報聘會員資料</td>
        </tr>

        <tr>
          <td align="center" bgcolor="#c6c4c4" class="text-weight-bold">姓名</td>
          <td align="center" bgcolor="#c6c4c4" class="text-weight-bold">身分證</td>
          <td align="center" bgcolor="#c6c4c4" class="text-weight-bold">姓名</td>
          <td align="center" bgcolor="#c6c4c4" class="text-weight-bold">身分證</td>
          <td align="center" bgcolor="#c6c4c4" class="text-weight-bold">首件回歸</td>
        </tr>

        <tr>
          <td align="center"></td>
          <td align="center"></td>
          <td align="center">{{ data.return_member_name }}</td>
          <td align="center">{{ data.return_member_ID_number }}</td>
          <td align="center">{{ data.first_return_plan === 'A' ? '永保' : '長安' }}</td>
        </tr>
      </table>
    </section>

    <section class="info-area">
      <table cellspacing="0">
        <tr>
          <td width="3%" rowspan="0" class="text-vertical" valign="center" align="center" bgcolor="#93d2fe">推薦</td>

          <td colspan="2" align="center" bgcolor="#93d2fe">推薦人</td>

          <td colspan="3" align="center" bgcolor="#ecb6b6">緊急聯絡人</td>
        </tr>

        <tr>
          <td align="center" bgcolor="#c6c4c4" class="text-weight-bold">姓名</td>
          <td align="center" bgcolor="#c6c4c4" class="text-weight-bold">業務編號</td>
          <td align="center" bgcolor="#c6c4c4" class="text-weight-bold">姓名</td>
          <td align="center" bgcolor="#c6c4c4" class="text-weight-bold">關係</td>
          <td align="center" bgcolor="#c6c4c4" class="text-weight-bold">電話</td>
        </tr>

        <tr>
          <td align="center">{{ data.upper_name }}</td>
          <td align="center">{{ data.upper_number }}</td>
          <td align="center">{{ data.emergency_name }}</td>
          <td align="center">{{ data.emergency_relation }}</td>
          <td align="center">{{ data.emergency_phone }}</td>
        </tr>
      </table>
    </section>

    <section class="info-area">
      <table cellspacing="0">
        <tr>
          <td width="3%" rowspan="0" class="text-vertical" valign="center" align="center" bgcolor="#93d2fe">銀行</td>

          <td colspan="5" align="center" bgcolor="#93d2fe">銀行資料</td>
        </tr>

        <tr>
          <td align="center" bgcolor="#c6c4c4" class="text-weight-bold">銀行名稱</td>
          <td align="center" bgcolor="#c6c4c4" class="text-weight-bold">分行名稱</td>
          <td align="center" bgcolor="#c6c4c4" class="text-weight-bold">分行代碼</td>
          <td align="center" bgcolor="#c6c4c4" class="text-weight-bold">銀行戶名</td>
          <td align="center" bgcolor="#c6c4c4" class="text-weight-bold">銀行帳號</td>
        </tr>

        <tr>
          <td align="center">{{ data.bank }}</td>
          <td align="center">{{ data.branch }}</td>
          <td align="center">{{ data.branchCode }}</td>
          <td align="center">{{ data.bank_name }}</td>
          <td align="center">{{ data.bank_account }}</td>
        </tr>
      </table>
    </section>

    <section class="info-area">
      <table cellspacing="0">
        <tr>
          <td align="center" bgcolor="#c6c4c4" class="text-weight-bold">收件</td>
          <td align="center" bgcolor="#c6c4c4" class="text-weight-bold">建檔</td>
          <td align="center" bgcolor="#c6c4c4" class="text-weight-bold">審核</td>
        </tr>

        <tr class="long">
          <td align="center"></td>
          <td align="center"></td>
          <td align="center"></td>
        </tr>
      </table>
    </section>

    <div class="bar-code">
      <img id="barCode_number" />

      <span>{{ data.number }}</span>
    </div>
  </div>
</template>

<script>
import jsbarcode from 'jsbarcode';
import { convertRocDate } from "@/models/HELPERS/common.js";

export default {
  name: 'BusinessCertificate',
  props: {
    width: {
      type: String,
      required: false,
      default: '100%'
    },
    data: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  watch: {
    'data.id': {
      handler(newValue, oldValue) {
        this.$nextTick(() => {
          this.generateBarcode();
        });
      },
      immediate: false
    }
  },
  data () {
    return {

    }
  },

  mounted() {
    this.load();
  },
  methods: {
    // 首次載入讀取
    load() {
      this.$nextTick(() => {
        this.generateBarcode();
      });
    },
    convertRocDate,
    generateBarcode() {
      jsbarcode(`#barCode_number`, this.data.number, {
        forat: "CODE39",
        margimnBottom: 5,
        font: "DFKai-sb",
        displayValue: false
      });
    }
  }
}
</script>

<style lang="scss" scoped>
* {
  font-family: DFKai-sb;
}

#BusinessCertificate_PrintTemplate {
  width: 794px;
  height: 1123px;
  .logo-area {
    display: grid;
    grid-template-columns: 1fr 1fr;
    row-gap: 5px;
    margin-bottom: 30px;
    .logo {
      height: 90px;
      width: 380px;
    }
    .logo-title {
      font-size: 26px;
      font-weight: bold;
      margin: auto 0 0 40px;
    }
  }
  .info-area {
    &:not(:last-child) {
      margin-bottom: 25px;
    }
    table {
      width: 100%;
      table-layout: fixed;
      word-wrap: break-word;
      word-break: normal;
      font-size: 18px;
      line-height: 1;
      border: 1px solid #000000;
      tr {
        height: 25px;
        &.long {
          height: 50px;
        }
        td {
          border: 1px solid #000000;
          &.text-weight-bold {
            font-weight: bold;
          }
          &.text-small {
            font-size: 16px;
          }
        }
      }
    }
  }
  .bar-code {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    font-size: 14px;
    font-weight: bold;
    width: 200px;
    height: auto;
    img {
      width: 100%;
      height: 35px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/common/PrintTemplate/BusinessCertificate.vue